import { useState } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { auth } from '../../services/api';
import { useNavigate } from 'react-router-dom';
import IcpFooter from '../../components/IcpFooter';

const { Title, Text } = Typography;

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await auth.login(values);
      localStorage.setItem('qhy_token', res.data.token);
      localStorage.setItem('qhy_user', JSON.stringify(res.data.user));
      message.success('登录成功');
      navigate('/dashboard');
    } catch (err) {
      message.error(err.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'linear-gradient(135deg, #0c3b7a 0%, #1a73e8 100%)', position: 'relative' }}>
      <Card style={{ width: 400, borderRadius: 12, boxShadow: '0 8px 24px rgba(0,0,0,0.15)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 48, marginBottom: 8 }}>🏭</div>
          <Title level={3} style={{ margin: 0 }}>黔好运能源管理平台</Title>
          <Text type="secondary">园区微电网+虚拟电厂+碳资产管理 一体化平台</Text>
        </div>
        <Form onFinish={onFinish} size="large">
          <Form.Item name="username" rules={[{ required: true, message: '请输入用户名' }]}>
            <Input prefix={<UserOutlined />} placeholder="用户名" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="密码" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              登录系统
            </Button>
          </Form.Item>
        </Form>
        {/* 小程序页面需要登录，未登录时不展示入口，避免被登录守卫弹回 */}
        {localStorage.getItem('qhy_token') && (
          <Button type="link" block style={{ marginTop: 8 }} onClick={() => navigate('/m')}>
            进入运维小程序 →
          </Button>
        )}
      </Card>
      <IcpFooter dark style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }} />
    </div>
  );
}
